module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/components/modal-search-box/modal-search-box.component.scss
// module id = ./src/app/modules/common-module/components/modal-search-box/modal-search-box.component.scss
// module chunks = 9